// Stable permission IDs seeded by Communication API. Role IDs and names are dynamic.
export enum CustomerUserManagementPermission {
  AddUser = '14700000-0000-4000-8000-000000000002',
  EditUser = '14700000-0000-4000-8000-000000000003',
  DeleteUser = '14700000-0000-4000-8000-000000000004',
  ManageRoles = '14700000-0000-4000-8000-000000000005',
}
